<script lang="ts">
import { defineComponent, inject, PropType } from 'vue';
import InputField from '@/Components/InputField.vue';
import { InputType } from '@/Types/InputTypes';
import { ICalculadoraStep9 } from '@/Types/Calculadora'
import { MaskType } from '@/Types/MaskTypes';


export default defineComponent({
    name: "FormularioCalculadoraStep9",
    components: {
        InputField,
    },
    props: {
        calculadora: {type: Object as PropType<ICalculadoraStep9>, required: true},
        editable: {type: Boolean},
    },
    data() {
        return {
            InputType,
            MaskType,
        }
    },
})
</script>

<template>
    <div class="step flex flex-col gap-[1rem]" id="step-3">
        <div>
            <p class="font-bold">Passo 9: Cronograma</p>
        </div>

        <div class="grid grid-cols md:grid-cols-2">
            <InputField
                name="data_lancamento_comercial"
                :is-required="true"
                v-model:value="calculadora.data_lancamento_comercial"
                :un-mask="false"
                placeholder=" "
                labelStyles="font-size: 1.4rem"
                label="Data do lançamento comercial"
                font-size="15px"
                class="w-full"
                :type="InputType.TEXT"
                :mask="MaskType.DATA"
                :col-span="1"/>
            <InputField
                name="prazo_vendas"
                :is-required="true"
                v-model:value="calculadora.prazo_vendas"
                :un-mask="false"
                placeholder=" "
                labelStyles="font-size: 1.4rem"
                label="Tempo de comercialização (meses)"
                font-size="15px"
                class="w-full"
                :type="InputType.TEXT"
                :mask="MaskType.NUMERO"
                :col-span="1"/>
            <InputField
                name="data_inicio_obra"
                :is-required="true"
                v-model:value="calculadora.data_inicio_obra"
                :un-mask="false"
                placeholder=" "
                labelStyles="font-size: 1.4rem"
                label="Data do início da obra"
                font-size="15px"
                class="w-full"
                :type="InputType.TEXT"
                :mask="MaskType.DATA"
                :col-span="1"/>
            <InputField
                name="prazo_obra"
                :is-required="true"
                v-model:value="calculadora.prazo_obra"
                :un-mask="false"
                placeholder=" "
                labelStyles="font-size: 1.4rem"
                label="Tempo de obra (meses)"
                font-size="15px"
                class="w-full"
                :type="InputType.TEXT"
                :mask="MaskType.NUMERO"
                :col-span="1"/>
        </div>
    </div>

</template>

<style scoped>

</style>